import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation SetWorkOSDsyncConfig($businessId: ID!, $launchAt: DateInput!) {
    setWorkOSDsyncConfig(businessId: $businessId, launchAt: $launchAt) {
      directorySyncConfig {
        uuid
        launchAt {
          seconds
        }
      }
    }
  }
`

export const setWorkOSDsyncConfigKey = getQueryNames(mutation)[0]

export default mutation
